const testimonialData = [
  {
    name: "Pranav Manbhekar",
    role: "Software Engineering  at Fivetran",
    content:
      "CPL and various knowledge sessions helped me in my competitive coding and interview preparation.CPL was quite helpful as it helped to improve competitive coding in a funway and it also improved coding culture. It would help beginners to kickstart their coding journey. Various off-campus opportunities were also posted which can help to avoid missing on opportunities.",
    img: "https://drive.google.com/thumbnail?id=1jim9ohyTPg7ryA8uz6pY9o8MpiZrzDfj",
    linkedin: "https://www.linkedin.com/in/pranav-manbhekar/",
  },

  {
    name: "Shrey Agrawal",
    role: "Power Programmer at Infosys",
    content:
      "My first experience with O(1) coding club was from their first seminar and since then, I have nothing but good things to say. From their guidance relating to placements, both on and off campus,to their CPL, everything important was explained and helped in becoming better programmers. I was fortunate enough lead a team in CPL, and watching me, my classmates, and juniors improve every contest was a great experience.",
    img: "https://drive.google.com/thumbnail?id=13g6hgR9zMoInK4bJli1S_u7eCQyuWVYr",
    linkedin: "https://www.linkedin.com/in/shrey-agrawal63/",
  },

  {
    name: "Sudhanshu Bhogal",
    role: "SDE-T at Amazon",
    content:
      "I took part in Coding Premier League and multiple Competitive Coding Streak contests organised by O(1) Coding Club.Before attending those events I was not able to solve even very simplecoding problems on Codechef and Codeforces but after receiving proper guidance on resources and improving thought process for solving problems by O(1) Coding Club, I improved a lot in few months. None of the interviews I gave had gone without solving a coding problem, so I would suggest to improve your competitive coding skill if you are not good in it and I would highly recommend to be part of O(1) Coding Club and take active participation in various contests and sessions organized by them.",
    img: "https://drive.google.com/thumbnail?id=1_YS_O8uI77QSc8p9FzDqrhV3hCOxptpu ",
    linkedin: "https://www.linkedin.com/in/sudhanshu-bhogal/",
  },
  {
    name: "Yavar Vazir",
    role: "MTS at VMware",
    content:
      "My preparation for Placements started with CPL organised by O(1) Coding Club.It was the best learning experience for me because it had coding problems of all levels, starting right from basics and going up to difficult problems to be solved in 2.5 - 3 hours. It made a good habit of solving problems on daily basis and helped us to have a grip on competitive coding questions. As far as the interviews are concerned, the videos uploaded by O(1) were very helpful particular to each company, where they told us what exactly do they expect and how to prepare for it. I would recommend to anyone who is looking for mentorship, guidance about placements, go for O(1).",
    img: "https://drive.google.com/thumbnail?id=1SXQ8LZOURmr8dG5ggTUhNYMEd-ubk8uN",
    linkedin: "https://www.linkedin.com/in/yavar-vazir-a0843a182/",
  },
  {
    name: "Rajat Bhanarkar",
    role: "Data Engineer  at Amazon",
    content:
      "I attended the React.js workshop by O(1) Coding Club in Jan. It was a really informative, interactive and organized workshop.Everything was developed from scratch with proper stepwise explanation.I would highly recommend O(1) Workshops.",
    img: "https://drive.google.com/thumbnail?id=1QlQvcfj4pItD0hTKp3toZxxEycsQYPOc",
    linkedin: "https://www.linkedin.com/in/rajat-bhanarkar-11a859176/",
  },
  {
    name: "Aditya Sharma ",
    role: " SE @ Akamai Tech",
    content: `I am associated with O(1) coding club for a long time and gained a lot of knowledge regarding coding and placements through it.
        With the help of different sessions conducted by O(1) coding club, I was able to bag dream package placements with offers like SDE at Persistent Systems and SDE-T at ZS associates.
        O1 also helped me in my second year to bag summer internship at Microland Ltd. with their guidance.
        Coderun helped me a lot to prepare for the placement season.`,
    img: "https://drive.google.com/thumbnail?id=1ici6-DvAE-I7Aqwwn7K77BRaeH8psmIR ",
    linkedin: "https://www.linkedin.com/in/aditya-sharma-0b21a3197/",
  },

  {
    name: "Nidhi Sharma",
    role: "SD  at Bank of New York Mellon",
    content:
      "O(1) has guided us, gave us great tips for making resume and ways to crack off-campus opportunities",
    img: "https://drive.google.com/thumbnail?id=14VJyh5KDLWyvrGsZuZ7-ujRZXzuH2PKJ",
    linkedin: "https://www.linkedin.com/in/nidhivsharma10/",
  },
  {
    name: "Akshay Mishra ",
    role: "Data Engineer @ Amazon",
    content: `I started my interview preparation journey from the first seminar of O(1). Things were explained very well in detail, from tips and tricks for interviews to resources for DSA and core subjects.CPL was one of the highlights for me as I was able to improve my problem solving skills significantly. I would recommend O(1) to every fresher looking for mentorship, guidance and a productive atmosphere to learn and grow.`,
    img: "https://drive.google.com/thumbnail?id=1Msw85PrrTqbPwBN5zo4uYsVI1o6Z5GDR",
    linkedin: "https://www.linkedin.com/in/akshay-mishra-1303/",
  },
  {
    name: "Amarkumar Mishra ",
    role: " BackEnd Developer @ HackerEarth",
    content: `I participated in CPL organized by O(1) Coding Club in May 2020 and I was team leader of my team. As, CPL was a team game it not only helped me to enhance my codingskills but also helped me to understand- 1. How to collaboratively solve a problem as a team. 2. Other better approaches for the same problem that you find out after discussing with your team mates. I would highly recommend to participate in CPL contest organized by O(1) coding club.`,
    img: "https://drive.google.com/thumbnail?id=1kTdUi_T-7qOBCkc8NKcBKGwCdec3iMrK",
    linkedin: "https://www.linkedin.com/in/amarkumar-m-48b08a172/",
  },
  {
    name: "Tejas Tapas ",
    role: " SDE @ ULA",
    content: `I was a part of the O(1) Coding Club for the last 1 year where I participated in some of their initiatives like CPL, coderun and aptitude series.
        I got to learn in a competitive environment with like-minded students and improve DSA and CP skills.
        The coding question which I solved during the CodeRun program highly benefited me in all companies Online Assessment and Interview rounds.`,
    img: "https://drive.google.com/thumbnail?id=1Q7wl6PZ2juNKgHn9SMhpHNvYbgdIXpBY",
    linkedin: "https://www.linkedin.com/in/tejas-sudhir-tapas/",
  },

  {
    name: "Sakshi Thakur ",
    role: " MTS @ VMware",
    content: `I have been helped a lot from O(1) club! Right from the first seminar, we have been guided in almost everything related to placements. I started participating rigorously in CPL aore subjects. As a fresher guidance and resources helped me to learn and grow.`,
    img: "https://drive.google.com/thumbnail?id=1xrZXG698XAPH2Qg3RvEppeUfvS4Kv3OS",
    linkedin: "https://www.linkedin.com/in/sakshithakur1612",
  },
  {
    name: "Vishal Kriplani ",
    role: " Software Engineer @ Fivetran",
    content: `The CPL helped me to maintain the speed and accuracy of problem-solving. Senior-Junior interaction was increased during these events. The Knowledge sessions were quite informative.`,
    img: "https://drive.google.com/thumbnail?id=1X-e43fWcbJUrGYfoWuJrEYdjUVNyr7dP",
    linkedin: "https://www.linkedin.com/in/vishal-kriplani-a33181190/",
  },
  {
    name: "Bhumika Nagrecha ",
    role: " SD @ Bank of New York Mellon",
    content: `I started my interview preparation journey from the first seminar of O(1). Things were explained very well in detail, from tips and tricks for interviews to resources for DSA andin contest streaks which improved my coding skills due to which I could clear the off-campus coding test for a job opportunity at Bank Of New York in my 3rd year itself . So in a nutshell, O(1) club is a single point solution for complete placement guidance.`,
    img: "https://drive.google.com/thumbnail?id=1jgevluDXgq6XiXDMpLG0oxz7guxGA5WM",
    linkedin: "https://www.linkedin.com/in/bhumikanagrecha/",
  },
  {
    name: "Monica Dholwani ",
    role: " SDE @ Fivetran",
    content: `O(1) Coding Club helped me achieve this opportunity. My mentors were always there to guide & train me.
        Initially I was not good at coding, I didn't even know what competitive coding is!
        All thanks to CodeRun program which helped me improve my coding skills and achieve a super dream job!`,
    img: "https://drive.google.com/thumbnail?id=1LZPRWUms3upHD6KXqw5eRIpdy2cEjtiy",
    linkedin: "https://www.linkedin.com/in/monica-dholwani/",
  },
  {
    name: "Halry Bhalodia ",
    role: " SDE-T @ ZS Associates",
    content: `At first, I didn't know where to start so I talked to mentors in O(1), they helped me from the beginning till the time I got placed in a Dream company, and even after that.
        With the help of Coderun, I could set a target for every day to practice coding questions and track my progress which helped me find out my weak topics and suggest related questions for more practice.
        Also, I could secure the Runner up position in Top Women Coders of Regional Challenge by Capgemini by practicing coding questions in coderun.`,
    img: "https://drive.google.com/thumbnail?id=1yyhfu73rOkLmg3NCLYBqLoWbp6A8XSV5",
    linkedin: "https://www.linkedin.com/in/monica-dholwani/",
  },

  {
    name: "Ashwin Walunj ",
    role: " PP @ Infosys",
    content: `So I joined the program called CodeRun conducted by the O(1) coding club, where we were provided with ladders of different levels and after every 3 days, we had doubt clearance sessions. What I understood was to trust the process and keep on enhancing your knowledge and expertise on the basics just combine this with a little bit of luck and you will also land a great job. Finally, I cleared the HackWithInfy and banged an offer for the role of power programmer. If it weren't for the O(1) coding club, I would've known this too late and might not have landed the job that I have now.`,
    img: "https://drive.google.com/thumbnail?id=15G6Ddii70YFxOjVbww1l4MfVb9EaSmQn ",

    linkedin: "https://www.linkedin.com/in/atharva-u-96436a191/",
  },
  {
    name: "Swaraj Chaudhari ",
    role: " FSE @ Accenture",
    content: `Observing myself before & after doing Coderun with  O(1) Coding Club, Now I am very confident. Now I know how exactly to proceed with a given problem. I would seriously recommend you to join the course. Coderun and the aptitude series helped a lot during the placement season.`,
    img: "https://drive.google.com/thumbnail?id=1YSwibu93qqjfLctfHHjC0JkxVb-7rGJV",
    linkedin: "https://in.linkedin.com/in/swaraj-chaudhari-860803180",
  },
  {
    name: "Atharva Upadhyay ",
    role: " PP @ Infosys",
    content: `O(1) coding club helped me alot to get focused and streamlined on what topics are important for each competitions/placement. Their personalised guidance and regular doubt sessions uplifted my problem solving skills and my confidence increased. Thank you O(1) coding club and specially Naman and Abhigyan sir to all your efforts in helping me to get such a wonderful placement. It was a great experience to learn and get inspired from you guys.`,

    img: "https://drive.google.com/thumbnail?id=1Nr9njJ1L-XH4Wd43v_qbaYnHQzkagy0p",
    linkedin: "https://www.linkedin.com/in/atharva-u-96436a191/",
  },
  {
    name: "Vignesh Pathak ",
    role: " FSE @ Accenture",
    content: `O1 Coding Club opened a new exciting world for me .  Without their training it would never been that friendly or postive entrance into the world of coding that helped me to get this far . It had played a crucial role in my academic life and my first successful Placement . Thank you for your invaluable help , you have opened new horizons for me !`,

    img: "https://drive.google.com/thumbnail?id=1-AgwTQPuItrD5Y9OxgcRMkP04ETVU49a",
    linkedin: "https://www.linkedin.com/in/vighnesh-pathak-4018b7192/",
  },
  {
    name: "Rohit Doshi ",
    role: " SDE @ Amazon",
    content: `Back in my 2nd year, I was clueless about what skills were needed to be in a good company.
        Mentors at O(1) Coding Club showed me the path to follow to land a great job.
        What I understood was to trust the process and keep on enhancing my knowledge and expertise on the basics.
        If it weren't for O(1) coding club, I would've known this too late and might not have landed the job that I have now.`,
    img: "https://drive.google.com/thumbnail?id=1_FiJk_IAz6ocACXWnVH9HFWzYncVVlZw",
    linkedin: "https://www.linkedin.com/in/rohit-bhavesh-doshi/",
  },
];
export default testimonialData;
